import React from 'react';
import { useNavigate } from 'react-router-dom';

const HomeSampleSection = () => {
  const navigate = useNavigate();

  // --- STYLES ---
  const sectionStyle = {
    backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('/images/sample-collection-banner.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed', 
    position: 'relative',
    borderRadius: '15px',
    overflow: 'hidden',
    minHeight: '300px', // Reduced slightly for better mobile aspect ratio
    display: 'flex',
    alignItems: 'center'
  };

  // Removed fixed padding/margin from here to handle it responsively via classes
  const contentStyle = {
    maxWidth: '600px', 
    color: 'white',
    textShadow: '2px 2px 4px rgba(0,0,0,0.7)'
  };

  return (
    <div className="container my-5">
      <div style={sectionStyle} className="shadow-lg">
        
        {/* FIX 1: Added 'p-3 p-md-5 m-2 m-md-4' for responsive spacing */}
        <div style={contentStyle} className="p-3 p-md-5 m-0 m-md-4">
            
            {/* FIX 2: Adjusted clamp minimum size to 1.1rem to fit small screens */}
            <h2 
              className="fw-bold mb-3" 
              style={{ 
                whiteSpace: 'nowrap', 
                fontSize: 'clamp(1.1rem, 4vw, 3rem)' 
              }}
            >
              Free Home Sample Collection
            </h2>

            <p className="mb-4 lead" style={{ fontSize: '1.1rem', fontWeight: '500' }}>
              Get your lab tests done from the comfort of your home. 
              Our expert phlebotomists will visit you at your preferred time.
              <br/><br/>
              
              <span className="badge bg-success fs-6">No hidden charges</span>
              
              {/* Responsive margin for the second badge */}
              <span className="badge bg-primary fs-6 ms-2 ms-md-3">100% Safe</span>
            </p>

            <button 
                onClick={() => navigate('/sample-collection')} 
                // FIX 3: Reduced horizontal padding (px-3) on mobile, px-5 on desktop
                className="btn btn-warning px-1 px-md-5 py-3 fw-bold text-dark shadow-sm rounded-pill text-nowrap" 
                style={{ fontSize: 'clamp(0.9rem, 2vw, 1.1rem)' }}
            >
               Home Sample Collection
            </button>
        </div>

      </div>
    </div>
  );
};

export default HomeSampleSection;